<iframe
    class="iframe-modal-class"
    [src]="url | domSafe"
    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen title="video-modal">
  </iframe>
